import React from 'react';
import Grid from '@mui/material/Grid2';
import TaskAssignmentTable from './task_assignment_table';
import TaskAssignmentButtons from './task_assignment_buttons';

const TaskAssignment = ({ handleAssignmentChange, handleSave, handleNotify, damTaskList, powerpointTaskList, noAssignUserList, assignedList, onNotifyChange, isNotifyDialogOpen }) => {
    return (
        <>
            <Grid container size={{ xs: 12 }} spacing={2}>
                <Grid size={{ xs: 12, md: 6 }}>
                    <TaskAssignmentTable
                        title="ダム業務割当"
                        onAssignmentChange={handleAssignmentChange}
                        category={"dam"}
                        damTaskList={damTaskList}
                        powerpointTaskList={powerpointTaskList}
                        noAssignUserList={noAssignUserList}
                        assignedList={assignedList}
                        onNotifyChange={onNotifyChange}
                        isNotifyDialogOpen={isNotifyDialogOpen}
                    />
                </Grid>
                <Grid size={{ xs: 12, md: 6 }}>
                    <TaskAssignmentTable
                        title="発電所業務割当"
                        onAssignmentChange={handleAssignmentChange}
                        category={"powerpoint"}
                        damTaskList={damTaskList}
                        powerpointTaskList={powerpointTaskList}
                        noAssignUserList={noAssignUserList}
                        assignedList={assignedList}
                        onNotifyChange={onNotifyChange}
                        isNotifyDialogOpen={isNotifyDialogOpen}
                    />
                </Grid>
            </Grid>
            <Grid sx={{ mt: 4 }}>
                <TaskAssignmentButtons
                    onSave={handleSave}
                    onNotify={handleNotify}
                />
            </Grid>
        </>
    );
};
export default TaskAssignment;